export const s: Record<string, React.CSSProperties> = {
  root: { padding: "14px 0 0" },

  sectionHeader: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between", marginBottom: "12px",
  },
  sectionTitle: { display: "flex", alignItems: "center", gap: "7px" },
  sectionAccent: {
    width: "3px", height: "16px",
    background: "#F8B71F", borderRadius: "99px",
  },
  sectionLabel: {
    fontSize: "12px", fontWeight: 600, color: "#374151",
    textTransform: "uppercase" as const, letterSpacing: "0.06em",
  },
  rowCount: { fontSize: "11px", color: "#9ca3af", fontWeight: 500 },

  colHeaders: {
    display: "grid",
    gridTemplateColumns: "190px 1fr 1fr 1fr 130px 36px", // ← added 36px for comment icon column
    padding: "0 44px 0 12px",
    marginBottom: "6px",
  },
  colHeader: {
    fontSize: "10.5px", fontWeight: 600, color: "#9ca3af",
    textTransform: "uppercase" as const, letterSpacing: "0.07em",
    padding: "0 6px",
  },

  rowWrap: {
    position: "relative" as const,
    marginBottom: "6px",
    marginRight: "44px",
    paddingRight: "44px",
  },
  rowCard: {
    display: "grid",
    gridTemplateColumns: "190px 1fr 1fr 1fr 130px 36px", // ← added 36px for comment icon column
    background: "#fafafa",
    border: "1px solid #ececec",
    borderRadius: "10px",
    padding: "10px 12px",
    alignItems: "start",
    transition: "border-color 0.15s, box-shadow 0.15s",
    position: "relative" as const,
    paddingRight: "40px",
  },
  rowCardSaved: { background: "#fff", borderColor: "#efefef" },
  rowCardNew: {
    outline: "2px solid transparent",
    borderLeft: "3px solid #F8B71F",
  },
  rowCardError: { borderColor: "#fca5a5", background: "#fffafa" },
  cell: { padding: "0 6px" },

  nameBadge: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    background: "#1a1a1a", color: "#fff",
    fontSize: "12px", fontWeight: 600,
    padding: "4px 10px", borderRadius: "6px",
    whiteSpace: "nowrap" as const, width: "fit-content",
  },
  nameDot: {
    width: "6px", height: "6px",
    borderRadius: "50%", background: "#F8B71F", flexShrink: 0,
  },

  dateDisplay: { fontSize: "12px", color: "#374151", padding: "6px 0", lineHeight: 1.4 },
  dateLabel: { fontSize: "10.5px", color: "#9ca3af", marginTop: "1px" },

  dateInput: {
    border: "1px solid #e2e2e2", borderRadius: "6px",
    padding: "6px 9px", fontSize: "11.5px", fontFamily: "inherit",
    color: "#374151", background: "#fff", outline: "none",
    width: "100%", cursor: "pointer",
    transition: "border-color 0.15s, box-shadow 0.15s",
  },
  remarksInput: {
    border: "1px solid #e2e2e2", borderRadius: "6px",
    padding: "6px 9px", fontSize: "12px", fontFamily: "inherit",
    color: "#374151", background: "#fff", outline: "none", width: "100%",
    transition: "border-color 0.15s, box-shadow 0.15s",
  },
  remarksDisabled: {
    border: "1px solid transparent", background: "transparent",
    color: "#6b7280", cursor: "default", paddingLeft: 0,
  },

  errText: {
    color: "#ef4444", fontSize: "10.5px",
    marginTop: "3px", display: "flex", alignItems: "center", gap: "3px",
  },

  uploadBtn: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    background: "#f3f4f6", border: "1px solid #e2e2e2", borderRadius: "6px",
    padding: "5px 10px", fontSize: "11px", fontWeight: 600, color: "#374151",
    cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" as const,
    transition: "background 0.15s",
  },
  fileItem: { display: "flex", alignItems: "center", gap: "4px", marginTop: "5px" },
  fileLink: {
    fontSize: "11px", color: "#2563eb", textDecoration: "none",
    maxWidth: "100px", overflow: "hidden",
    textOverflow: "ellipsis", whiteSpace: "nowrap" as const, display: "inline-block",
  },
  fileDelBtn: {
    background: "none", border: "none", cursor: "pointer",
    color: "#ef4444", display: "flex", alignItems: "center",
    padding: "1px", borderRadius: "3px",
  },
  progressText: { fontSize: "11px", color: "#97b4ee" },
  progressWrap: {
    height: "3px", background: "#e5e7eb",
    borderRadius: "99px", marginTop: "3px", width: "100%",
  },

  rowActions: {
    position: "absolute" as const,
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    flexDirection: "column" as const,
    gap: "4px",
  },
  rowActionBtn: {
    width: "28px", height: "28px", borderRadius: "7px",
    border: "none", display: "flex", alignItems: "center",
    justifyContent: "center", cursor: "pointer",
    transition: "background 0.15s",
  },

  addRowBtn: {
    background: "none", border: "1px dashed #d1d5db",
    borderRadius: "8px", padding: "6px 14px",
    fontSize: "12px", color: "#9ca3af", fontFamily: "inherit",
    cursor: "pointer", width: "100%", marginTop: "4px",
    transition: "border-color 0.15s, color 0.15s",
  },

  footer: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "12px 0 0", borderTop: "1px solid #f0f0f0", marginTop: "8px",
  },
  footerLeft: { fontSize: "11.5px", color: "#9ca3af" },
  saveBtn: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    background: "#F8B71F", border: "none", borderRadius: "7px",
    padding: "7px 16px", fontSize: "12.5px", fontWeight: 600,
    color: "#1a1a1a", cursor: "pointer", fontFamily: "inherit",
    boxShadow: "0 1px 4px rgba(248,183,31,0.35)",
    transition: "background 0.15s",
  },
  saveBtnDisabled: {
    background: "#e5e7eb", color: "#9ca3af",
    cursor: "not-allowed", boxShadow: "none",
  },

  /* comment icon cell */
  commentIconBtn: {
    width: "28px", height: "28px", borderRadius: "7px", border: "none",
    background: "#f3f4f6", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#9ca3af", transition: "background 0.15s, color 0.15s",
    position: "relative" as const,
    marginTop: "2px",
  },
  commentBadge: {
    position: "absolute" as const, top: "-4px", right: "-4px",
    width: "14px", height: "14px", borderRadius: "50%",
    background: "#F8B71F", color: "#1a1a1a",
    fontSize: "8px", fontWeight: 700,
    display: "flex", alignItems: "center", justifyContent: "center",
    border: "1.5px solid #fff",
  },
};

// ── react-select styles ───────────────────────────────────────────────────────

export const selectStyles = (hasError: boolean) => ({
  control: (base: any, state: any) => ({
    ...base,
    fontSize: "12px",
    minHeight: "32px",
    borderColor: hasError ? "#ef4444" : state.isFocused ? "#F8B71F" : "#e2e2e2",
    boxShadow: state.isFocused
      ? hasError ? "0 0 0 2px rgba(239,68,68,0.18)" : "0 0 0 2px rgba(248,183,31,0.18)"
      : "none",
    "&:hover": { borderColor: hasError ? "#ef4444" : "#F8B71F" },
    borderRadius: "6px",
    background: "#fff",
  }),
  option: (base: any, state: any) => ({
    ...base,
    fontSize: "12px",
    background: state.isSelected ? "#F8B71F" : state.isFocused ? "#fef9c3" : "#fff",
    color: state.isSelected ? "#1a1a1a" : "#374151",
  }),
  placeholder: (base: any) => ({ ...base, fontSize: "12px", color: "#9ca3af" }),
  menu: (base: any) => ({ ...base, borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)", zIndex: 20 }),
  valueContainer: (base: any) => ({ ...base, padding: "2px 8px" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base: any) => ({ ...base, padding: "4px" }),
});
